import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=57800336&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57800336')) {
      api.createRecord('57800336', component.options)
    } else {
      api.reload('57800336', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=57800336&", function () {
      api.rerender('57800336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qT8cvzCv2rt0/JS/offershelp.vue"
export default component.exports